import axios from "axios";
import React, { useEffect, useState } from "react";
import "../../../style/css/admin/User.css";
import { Navbar } from "../../../commn/Navbar.js";
import NavLink, { Link, useNavigate } from "react-router-dom";
import { AiOutlineDownload } from "react-icons/ai";

export const EntrepreneurshipA = () => {
  const [data, setData] = useState([]);

  const navi = new useNavigate();

  useEffect(() => {
    try {
      axios.get("/api/entrepreneurship/get").then((res) => {
        setData(res.data);
      });
    } catch (err) {
      console.log(err);
    }
  });
  //delete
  const Deleteadmin = (id) => {
    axios.delete(`/api/entrepreneurship/delete/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.get("user")).token,
      },
    });
    alert("Send Message");
    navi("/Aentra");
  };

  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div className="mt-5" style={{ textAlign: "center" }}>
        <div className="dbtn">
          <Link to="/Aentraemail">
            <button className="btn btn-primary mt-5">
              Entrepreneurship Email
            </button>
          </Link>
        </div>
        <div className="td container">
          <h3>Entrepreneurship form Details</h3>
          <table
            className="table shadow"
            style={{ width: "80%", marginLeft: "10%", marginRight: "10%" }}
          >
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Address</th>
                <th scope="col">Business Name</th>
                <th scope="col">Email</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {data.map((user) => {
                return (
                  <tr>
                    <td>{user.name}</td>
                    <td>{user.address}</td>
                    <td>{user.businessname}</td>
                    <td>{user.email}</td>

                    <td>
                      {/* <Link to={`/updateuser/${user._id}`}>
                                    <button className='btn'>Update</button>
                               </Link> */}
                      <Link to={`/Aentradetails/${user._id}`}>
                        <button className="btn btn-primary">More</button>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
